import Head from 'next/head'
import { isEmpty } from 'lodash-es'
import { stringify } from 'qs'

import { LS_APP_DOMAIN } from 'config/constants'

const genTitle = (serviceCounty, district, serviceClassificationFilter) => {
  let title = '尋找'
  if (serviceCounty) {
    title += `在${serviceCounty}${district || ''}`
  }
  title += `可提供${
    serviceClassificationFilter?.name || '居住生活相關'
  }服務的廠商 - 信義居家`
  return title
}

const genDesc = (serviceCounty, district, serviceClassificationFilter) => {
  let desc = ''
  if (serviceCounty) {
    desc += `這是在${serviceCounty}${district || ''}`
  }
  desc += `可提供${
    serviceClassificationFilter?.name || '居家相關'
  }服務的廠商，經過信義居家嚴格品選出的優質合作夥伴，要給你一個溫馨舒適的家，需要${
    serviceClassificationFilter?.name || '居住生活相關'
  }服務，請務必交給我們為您服務。`
  return desc
}

const MetaTags = ({
  resolvedUrl,
  serviceCounty,
  district,
  serviceClassificationFilter,
  searchText,
  page,
}) => {
  const pathName = resolvedUrl.split('?')[0]

  const isSearchPage = /search/.test(pathName)

  const originUrl = `${LS_APP_DOMAIN + pathName}`
  const qs = {
    page: 1,
  }
  if (isSearchPage) {
    qs.keyword = searchText
  }
  if (serviceCounty) {
    qs.serviceCounty = serviceCounty
    if (district) {
      qs.district = district
    }
  }
  if (serviceClassificationFilter) {
    qs.serviceItem = serviceClassificationFilter._id
  }
  let path = isSearchPage ? `${originUrl}/search` : originUrl
  if (!isEmpty(qs)) {
    path += `?${stringify(qs)}`
  }

  const title = genTitle(serviceCounty, district, serviceClassificationFilter)

  const description = genDesc(
    serviceCounty,
    district,
    serviceClassificationFilter
  )

  return (
    <Head>
      {!!title && <title>{title}</title>}

      {!!description && (
        <meta key="description" name="description" content={description} />
      )}

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      {!!description && (
        <meta key="description" name="description" content={description} />
      )}

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      {!!description && (
        <meta
          key="og:description"
          property="og:description"
          content={description}
        />
      )}

      <link key="canonical" rel="canonical" href={path} />

      {/* For Facebook */}
      <meta key="og:url" property="og:url" content={path} />
    </Head>
  )
}

export default MetaTags
